import { Card, Badge, Spinner } from 'react-bootstrap';

function UserBreakdownCard({ loading, adminCount, editorCount, viewerCount, activeUsers, pendingUsers, suspendedUsers }) {
  return (
    <Card className="dashboard-card border-0 h-100">
      <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
        <h6 className="mb-0 fw-semibold">
          <i className="bi bi-shield-check me-2 text-primary"></i>User Breakdown
        </h6>
      </Card.Header>
      <Card.Body className="pt-2">
        {loading ? (
          <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>
        ) : (
          <>
            <p className="text-muted small mb-2 text-uppercase fw-semibold" style={{ letterSpacing: '0.05em' }}>By Role</p>
            <div className="d-flex justify-content-between align-items-center mb-2 px-3 py-2 rounded" style={{ background: '#fff0f0' }}>
              <span><Badge bg="danger" className="me-2">Admin</Badge><small className="text-muted">Full access</small></span>
              <strong>{adminCount}</strong>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2 px-3 py-2 rounded" style={{ background: '#eef2ff' }}>
              <span><Badge bg="primary" className="me-2">Editor</Badge><small className="text-muted">Register &amp; edit</small></span>
              <strong>{editorCount}</strong>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-3 px-3 py-2 rounded" style={{ background: '#f5f5f5' }}>
              <span><Badge bg="secondary" className="me-2">Viewer</Badge><small className="text-muted">Read only</small></span>
              <strong>{viewerCount}</strong>
            </div>
            <hr className="my-3" />
            <p className="text-muted small mb-2 text-uppercase fw-semibold" style={{ letterSpacing: '0.05em' }}>By Status</p>
            <div className="d-flex justify-content-around text-center">
              <div>
                <div className="fw-bold fs-5 text-success">{activeUsers}</div>
                <small className="text-muted">Active</small>
              </div>
              <div className="border-start border-end px-3">
                <div className="fw-bold fs-5 text-warning">{pendingUsers}</div>
                <small className="text-muted">Pending</small>
              </div>
              <div>
                <div className="fw-bold fs-5 text-danger">{suspendedUsers}</div>
                <small className="text-muted">Suspended</small>
              </div>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default UserBreakdownCard;
